/**
 * MEOWSING — cat companion overlay
 *
 * Its single web-accessible-resource entry exposes `resources/*.gif` and `resources/*.mp3`
 * to `<all_urls>` with no `use_dynamic_url` — so the bundled animation frames and audio
 * are fetchable from any page at a fixed URL. The vendor-named popup GIFs load through
 * `probeImage` with no CORS grant, and a background meow `.mp3` corroborates via fetch.
 *
 * Manifest verified against version 1.4.3.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bbfbeaopdnagijhehlhajpjnfghdhohm';

export const meowsing: ExtensionDefinition = {
  id: ID,
  name: 'MEOWSING',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  notes:
    'Exposes resources/*.gif and resources/*.mp3 to <all_urls> with no dynamic URL. The ' +
    'popup GIFs load without a CORS grant; detection is conclusive.',
  signals: [
    {
      id: 'war-logo-catday-gif',
      kind: 'web-accessible-resource',
      description:
        'Load resources/popup/logo_catday.gif via <img> — a vendor-named animation ' +
        'exposed to every origin; needs no CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'resources/popup/logo_catday.gif'),
    },
    {
      id: 'war-loading-gif',
      kind: 'web-accessible-resource',
      description:
        'Load resources/popup/loading.gif via <img> — a second GIF path that corroborates.',
      weight: 0.5,
      run: () => probeImage(ID, 'resources/popup/loading.gif'),
    },
    {
      id: 'war-meow-audio-mp3',
      kind: 'web-accessible-resource',
      description:
        'Fetch resources/meow_audio/background/cat_1.mp3 — a bundled audio clip, an ' +
        'independent non-image path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'resources/meow_audio/background/cat_1.mp3'),
    },
  ],
};
